<template>
  <section class="c-list-guests">
    <div class="container">
      <div class="columns is-gapless is-vcentered">
        <div class="column">
          <h2
            class="margin-bottom c-list-guests__title is-size-3 has-text-weight-bold"
          >
            Lista de presença
          </h2>
        </div>
        <div v-if="hasContentList" class="column">
          <div class="columns is-justify-content-center is-hidden-tablet">
            <div class="column">
              <button
                type="button"
                @click="getGuestList"
                class="button is-neutral-outlined is-inline-flex"
                :disabled="loadingDownload"
              >
                <base-icon
                  name="painel/download"
                  width="24"
                  height="24"
                  style="margin-right: 8px"
                />
                Baixar lista de convidados
              </button>
            </div>
            <div v-if="isClosed" class="column">
              <router-link
                :to="{ path: `/rsvp/cadastrar-convites` }"
                class="button is-support button-create-invites inline-flex"
              >
                <base-icon
                  name="painel/add-circle-icon"
                  width="24"
                  height="24"
                  style="margin-right: 8px"
                />
                Cadastrar convites
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-12-tablet is-5-desktop">
          <div class="field">
            <p class="control has-icons-left">
              <input
                v-model="searchName"
                class="c-list-guests__input input is-rounded"
                type="text"
                placeholder="Buscar um convidado"
              />
              <span
                height="46px"
                class="c-list-guests__search-icon icon is-left"
              >
                <base-icon
                  class="has-text-grey-dark"
                  width="20"
                  height="20"
                  name="painel/search-icon"
                />
              </span>
            </p>
          </div>
        </div>
        <div
          v-if="hasContentList"
          class="column has-text-right is-hidden-mobile"
        >
          <div class="columns is-mobile is-justify-content-flex-end">
            <div class="column is-narrow">
              <button
                type="button"
                @click="getGuestList"
                class="button is-neutral-outlined is-inline-flex"
                :disabled="loadingDownload"
              >
                <base-icon
                  name="painel/download"
                  width="24"
                  height="24"
                  style="margin-right: 8px"
                />
                Baixar lista de convidados
              </button>
            </div>
            <div v-if="isClosed" class="column is-narrow">
              <router-link
                :to="{ path: `/rsvp/cadastrar-convites` }"
                class="button is-support button-create-invites inline-flex"
              >
                <base-icon
                  name="painel/add-circle-icon"
                  width="24"
                  height="24"
                  style="margin-right: 8px"
                />
                Cadastrar convites
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <ListGuestsTab :search="searchName" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ListGuestsTab from '@/components/Rsvp/ListGuestsTab.vue'
import RsvpApi from '@/lib/api/Rsvp'

const APP_ENV = process.env.VUE_APP_ENV

export default {
  components: {
    ListGuestsTab,
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedSiteInfo: 'app/getWedSiteInfo',
      rsvpAmountAllTotal: 'rsvpAmountAllTotal',
      rsvpConfigs: 'getRsvpConfigs',
    }),

    hasContentList() {
      return this.rsvpAmountAllTotal > 0
    },

    isClosed() {
      return this.rsvpConfigs?.mode === 'closed'
    },
  },

  data() {
    return {
      searchName: '',
      loadingDownload: false,
    }
  },

  methods: {
    getGuestList() {
      if (this.loadingDownload) return
      this.loadingDownload = true
      const domain = this.getUrlWedding()
      const rsvpApi = new RsvpApi(this.logonToken)
      rsvpApi
        .downloadGuestsList(domain)
        .then((response) => {
          let url = ''

          APP_ENV === 'local'
            ? (url = response.data.data.replace('localstack', '172.20.0.12'))
            : (url = response.data.data)

          const fileLink = document.createElement('a')

          fileLink.href = url
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .finally(() => {
          this.loadingDownload = false
        })
    },

    getUrlWedding() {
      const url = this.wedSiteInfo.site_url

      let arrayUrl = url.split('/')

      // return if site interno
      if (arrayUrl.length > 1) {
        return arrayUrl[1]
      }

      // site with domain
      arrayUrl = url.split('.')
      return arrayUrl[0]
    },
  },
}
</script>

<style lang="scss">
.is-btn-download-icon {
  background-color: transparent;
  border: none;
  width: fit-content;
  padding: 0 10px;
}

.button.is-btn-download-icon:focus,
.button.is-btn-download-icon:hover,
.button.is-btn-download-icon.is-focused {
  box-shadow: 0 0 0 0.125em rgba(61, 175, 176, 0);
  border-color: transparent;
}

.button.is-btn-download-icon[disabled] {
  background-color: transparent;
}

.c-list-guests {
  padding: 2em 1em;
  background-color: $gray-2;

  &__title {
    color: $neutraldarkest;
  }

  &__input.input {
    padding-left: 50px !important;
    height: 46px;
    border: 1px solid $gray-4;
    background-color: $white;
    &:focus {
      color: $gray-5;
    }
    &::placeholder {
      color: $gray-4;
      font-weight: bold;
    }
  }

  &__search-icon.icon {
    width: 60px !important;
    height: 46px !important;
  }
}
</style>
